<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc-f"><a href="#/xhtml/05_ListMaps">List of Maps</a></h2>
<h2 class="toc-f"><a href="#/xhtml/06_Editors">Series Editor’s Introduction</a></h2>
<h2 class="toc-f"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toc-f"><span href="#/xhtml/08_Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/09_Chapter01" title="Link target outside of Sample"><span class="bold">Chapter 1</span><span class="space-1">The Somme Battle 1916: September to the Battle’s End</span></span></h2>
<h2 class="toc-ch"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample"><span class="bold">Chapter 2</span><span class="space-1">Mid-September success – Martinpuich is taken</span></span></h2>
<h2 class="toc-ch"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample"><span class="bold">Chapter 3</span><span class="space-1">Early October: Eaucourt l’Abbaye is taken</span></span></h2>
<h2 class="toc-ch"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample"><span class="bold">Chapter 4</span><span class="space-1">The Advance from Eaucourt l’Abbaye to the capture of Le Sars on 8 October</span></span></h2>
<h2 class="toc-ch"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample"><span class="bold">Chapter 5</span><span class="space-1">The further attempts to capture the Butte de Warlencourt: October and November 1916</span></span></h2>
<h2 class="toc-b"><span href="#/xhtml/14_Guide" title="Link target outside of Sample">A Guide to the Book and to Visiting the Battlefields</span></h2>
<h2 class="toc-b"><a href="#/xhtml/15_Tour1">Walking Tour 1<span class="space-1">The area around the Butte de Warlencourt</span></a></h2>
<h2 class="toc-b"><a href="#/xhtml/16_Tour2">Walking Tour 2<span class="space-1">Martinpuich and Area</span></a></h2>
<h2 class="toc-b"><span href="#/xhtml/17_Touring" title="Link target outside of Sample">Touring the area by vehicle: Behind the German Lines</span></h2>
<h2 class="toc-b"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample">Selected Reading and Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?94f86716